import React, { Component } from 'react';

class IconTicketLegend extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="6" fill="none" viewBox="0 0 13 6">
                <path
                    fill={this.props.iconColor}
                    d="M9.625 0H2.768C1.348 0 .196 1.343.196 3s1.152 3 2.572 3h6.857c1.42 0 2.571-1.343 2.571-3s-1.151-3-2.571-3z"
                ></path>
            </svg>
        );
    }
}

export default IconTicketLegend;